import Vue from 'vue';
// import _ from 'lodash';
import {
    GET_ORDER_DETAIL_REQUEST,
    GET_ORDER_DETAIL_SUCCESS,
    GET_ORDER_DETAIL_FAILURE,
    UPDATE_ORDER_DETAIL_PARAMS
} from '../mutationTypes';

const operateHeader = [
    {label: '操作账号', prop: 'count_name', 'min-width': '100'},
    {label: '姓名', prop: 'name', 'min-width': '100'},
    {label: '角色', prop: 'role', 'min-width': '100'},
    {label: '操作', prop: 'detail', 'min-width': '100'},
    {label: '操作时间', prop: 'time', 'min-width': '100'}
];

const state = {
    isNotData: {
        type: '',
        msg: ''
    },
    loading: false,
    reqParams: {
        orderId: '', // 订单id
        businessType: '', // 业务类型id
    },
    orderDetail: {
        orderInfo: {},
        carInfo: {},
        associatedOrder: {},    // 关联订单信息
        serverInfo: [],         // 服务信息
        goodsInfo: [],          // 商品信息
        settlementInfo: {},     // 结算信息
        buyInfo: [],            // 购买信息
        operate: [],            // 操作记录
    },
    operateHeader,
};

const mutations = {
    [GET_ORDER_DETAIL_REQUEST](state) {
        state.loading = true;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_ORDER_DETAIL_SUCCESS](state, res) {
        let needCounterSettlement = true; // 反结算
        let needCopyOrder = true; // 再来一单
        const goodsInfo = [];
        res.goodsInfo.forEach((item) => {
            if (item.goodsOrder) {
                needCounterSettlement = false;
                item.orderInfo.forEach((orderGoods) => {
                    goodsInfo.push(Object.assign(orderGoods, {goodsOrder: item.goodsOrder}));
                });
            } else {
                goodsInfo.push(item);
                if (item.goodsType === 1) {
                    needCounterSettlement = false;
                    needCopyOrder = false;
                }
            }
        });
        if (res.orderInfo.orderState !== 2 || res.orderInfo.isCounterSettlement || (new Date(res.orderInfo.settlementTime).getTime() + 2592000000) < (res.orderInfo.nowTime * 1000)) needCounterSettlement = false;
        if (res.orderInfo.orderState !== 4) needCopyOrder = false;
        const cache = res;
        cache.goodsInfo = goodsInfo;
        cache.orderInfo.needCounterSettlement = needCounterSettlement;
        cache.orderInfo.needCopyOrder = needCopyOrder;
        state.orderDetail = cache;
        state.loading = false;
        // reset noData info
        state.isNotData.type = false;
    },
    [GET_ORDER_DETAIL_FAILURE](state, res) {
        state.loading = false;
        if (res.errorType) {
            state.isNotData.type = true;
            state.isNotData.msg = res.errmsg;
        } else {
            state.isNotData.type = false;
            state.isNotData.msg = '';
        }
        // reset orderDetail
        state.orderDetail = {};
    },
    [UPDATE_ORDER_DETAIL_PARAMS](state, params) {
        const { orderId, businessType } = params;
        if (orderId || orderId === '') state.reqParams.orderId = orderId;
        if (businessType || businessType === '') state.reqParams.businessType = businessType;
    }
};

export const actions = {
    async getOrderDetail({ commit }) {
        commit(GET_ORDER_DETAIL_REQUEST);
        const res = await Vue.$ajax.get('getGainDetail', state.reqParams);
        if (!res.errorType) {
            commit(GET_ORDER_DETAIL_SUCCESS, res);
        } else {
            commit(GET_ORDER_DETAIL_FAILURE, res);
        }
    },
    resolveOrderDetailParams({ commit }) {
        const params = state.reqParams;
        commit(UPDATE_ORDER_DETAIL_PARAMS, params);
    }
};

export default {
    state,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/orderDetail.js